/**
 * @file environmentIndicator.ts
 * @module _admin/layout/core/environmentIndicator
 * @description Provides the environmentIndicator layout-core component, configuration, or context used to initialize and manage UTrade Admin layout state.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.3.5
 */

export const getEnvironmentIndicatorClass = (environment?: string): string => {
  const normalizedEnvironment = (environment || "").trim().toLowerCase();

  if (normalizedEnvironment === "production") {
    return "";
  }

  if (
    normalizedEnvironment === "stage" ||
    normalizedEnvironment === "staging" ||
    normalizedEnvironment === "preprod" ||
    normalizedEnvironment === "pre-prod" ||
    normalizedEnvironment === "pre_prod"
  ) {
    return "app-header--stage";
  }

  return "app-header--non-prod";
};
